export const CHANGE_WALLPAPER = 'CHANGE_WALLPAPER'